export function hideEmail(email: string): string {
	const emailParts = email.split("@");
	if (emailParts.length !== 2) {
		return "";
	}

	const asterisks = "**********";
	const [local, domain] = emailParts;

	let prefix = "";
	if (local.length >= 3) {
		prefix = local.slice(0, 3);
	}

	let suffix = "";
	if (local.length >= prefix.length + asterisks.length) {
		suffix = local.slice(local.length - 3);
	}

	return `${prefix}${asterisks}${suffix}@${domain}`;
}

const NON_DIGITS = /[^0-9]+/g;
const HIDDEN_FORMAT = /(\*{2})(\*{5})(\d{4})$/;

export function cleanNonDigits(phone: string): string {
	let cleaned = phone.replace(NON_DIGITS, "");

	if (cleaned.length > 11) {
		cleaned = cleaned.slice(2);
	}

	return cleaned;
}
export function hidePhone(phone: string): string {
	const cleaned = cleanNonDigits(phone);
	if (cleaned.length !== 11) {
		return cleaned;
	}

	const masked = `*******${cleaned.slice(7)}`;
	return masked.replace(HIDDEN_FORMAT, "($1) $2-$3");
}

export interface HiddenContact {
	hidden_email?: string;
	hidden_phone?: string;
}

export function buildHiddenContact(
	email: string,
	phone: string,
): HiddenContact {
	const result: HiddenContact = {};

	const hiddenEmail = hideEmail(email);
	if (hiddenEmail !== "") {
		result.hidden_email = hiddenEmail;
	}

	const hiddenPhone = hidePhone(phone);
	if (hiddenPhone !== "") {
		result.hidden_phone = hiddenPhone;
	}

	return result;
}
